import WidgetView from '@pok/weblib/ui/WidgetView';
import Grid from '@mui/material/Grid';
import { useTranslation } from 'react-i18next';

export default function WidgetsContainer({ widgets, yPosition, color, onClick }) {
    const { t } = useTranslation();
    const yWidgets = widgets?.filter((x) => x.yPosition === yPosition) || [];
    const hasWidgets = yWidgets.length > 0;
    const leftWidget = yWidgets.find((x) => x.xPosition === 'left');
    const rightWidget = yWidgets.find((x) => x.xPosition === 'right');

    return (
        <>
            {hasWidgets && (
                <Grid container spacing={1} mb={1} justifyContent={'center'} textAlign={'-webkit-center'}>
                    {leftWidget && (
                        <Grid size={{ md: 6, xs: 12 }}>
                            <WidgetView widget={leftWidget} t={t} color={color} onClick={onClick} />
                        </Grid>
                    )}
                    {rightWidget && (
                        <Grid size={{ md: 6, xs: 12 }}>
                            <WidgetView widget={rightWidget} t={t} color={color} onClick={onClick} />
                        </Grid>
                    )}
                </Grid>
            )}
        </>
    );
}
